import type {
  PublicationFetchForTopicPayload,
  PublicationFetchForTopicSuccessAction,
} from "entities/publication/actionTypes";
import type { ErrorMeta } from "types/redux";

export enum VideoActionTypes {
  FETCH_FOR_TOPIC = "entities/VIDEOS_FETCH_FOR_TOPIC",
  FETCH_FOR_TOPIC_SUCCESS = "entities/VIDEOS_FETCH_FOR_TOPIC_SUCCESS",
  FETCH_FOR_TOPIC_FAILURE = "entities/VIDEOS_FETCH_FOR_TOPIC_FAILURE",
}

type VideosFetchForTopicPayload = Omit<PublicationFetchForTopicPayload, "language">;

export type VideosFetchForTopicAction = {
  meta: { forceRefresh?: boolean };
  payload: VideosFetchForTopicPayload;
  type: VideoActionTypes.FETCH_FOR_TOPIC;
};

export type VideosFetchForTopicSuccessAction = Omit<PublicationFetchForTopicSuccessAction, "type"> & {
  type: VideoActionTypes.FETCH_FOR_TOPIC_SUCCESS;
};

type VideosFetchForTopicFailureMeta = ErrorMeta & { searchCriteria: VideosFetchForTopicPayload };

export type VideosFetchForTopicFailureAction = {
  meta: VideosFetchForTopicFailureMeta;
  type: VideoActionTypes.FETCH_FOR_TOPIC_FAILURE;
};

export type VideosAction =
  | VideosFetchForTopicAction
  | VideosFetchForTopicSuccessAction
  | VideosFetchForTopicFailureAction;
